import React from 'react';

const Settings = () => {
  return (
    <div>
      <h1>Settings Page</h1>
      <p>Welcome to the Settings!</p>
    </div>
  );
};

export default Settings;